import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  // connect() {
  //   alert('shit')
  // }

  reset() {
    this.element.reset()
  }

  disable() {
    const submitBtn = this.element.querySelector('input[type="submit"]')
    if (submitBtn) {
      submitBtn.disabled = true
      submitBtn.value = '...saving'
    }
  }

}
